import { documentsToApproveToolbarActions } from '../utils';
import ApproveItemsModal from '../components/ApproveItemsModal';
import RejectItemsModal from '../components/RejectItemsModal';

const FILTER_BUTTON = 0;
const DOWNLOAD_BUTTON = 1;
const REJECT_BUTTON = 2;
const APPROVE_BUTTON = 3;


const setupFilterButton = (toggleAdvancedFilter) => {
  documentsToApproveToolbarActions[FILTER_BUTTON].props.onClick = toggleAdvancedFilter;
};

const setupApproveButton = (modalContext, selectedItems, doApproveDocuments) => {
  documentsToApproveToolbarActions[APPROVE_BUTTON].props.disabled = !selectedItems || selectedItems.length === 0;
  documentsToApproveToolbarActions[APPROVE_BUTTON].props.onClick = () => {
    const content = {
      component: ApproveItemsModal,
      props: {
        doApproveDocuments,
        selectedItems
      }
    };
    modalContext.setContent(content);
    modalContext.toggle();
  };
};

const setupRejectButton = (modalContext, selectedItems, doRejectDocuments) => {
  documentsToApproveToolbarActions[REJECT_BUTTON].props.disabled = !selectedItems || selectedItems.length === 0;
  documentsToApproveToolbarActions[REJECT_BUTTON].props.onClick = () => {
    const content = {
      component: RejectItemsModal,
      props: {
        doRejectDocuments,
        selectedItems
      }
    };
    modalContext.setContent(content);
    modalContext.toggle();
  };
};

const setupDownloadButton = (selectedItems, doDownloadDocuments) => {
  documentsToApproveToolbarActions[DOWNLOAD_BUTTON].props.disabled = !selectedItems || selectedItems.length === 0;
  documentsToApproveToolbarActions[DOWNLOAD_BUTTON].props.onClick = () => {
    doDownloadDocuments(selectedItems.map(item => item.id));
  };
};

export const setupDocumentsToApproveToolbarActions = (params) => {
  const { 
    context, 
    selectedItems, 
    toggleAdvancedFilter, 
    doApproveDocuments, 
    doRejectDocuments, 
    doDownloadDocuments 
  } = params;
  setupFilterButton(toggleAdvancedFilter);
  setupApproveButton(context, selectedItems, doApproveDocuments);
  setupRejectButton(context, selectedItems, doRejectDocuments);
  setupDownloadButton(selectedItems, doDownloadDocuments);
};
